import { useTranslation } from 'react-i18next';
import { CommonUsagePanel, type CommonUsageItem } from '../../_shared/CommonUsagePanel';

const COMMON_USAGE_ITEMS: CommonUsageItem[] = [
  {
    module: 'eraf-scheduler ★C064',
    moduleColor: 'purple',
    api: 'SchedulerRunHistoryRepository.findAll(spec, p)',
    role: '스케줄 실행 이력 페이지 조회',
    snippet: 'repo.findAll(spec, sortedPageable)',
  },
  {
    module: 'eraf-scheduler ★C064',
    moduleColor: 'purple',
    api: 'SchedulerRunStatus (SUCCESS/FAILED/SKIPPED)',
    role: '실행 상태 Pill',
    snippet: 'StatusPill tone={runStatusTone(status)}',
  },
  {
    module: 'eraf-scheduler ★C064',
    moduleColor: 'purple',
    api: '@ErafScheduled(name="demo-heartbeat")',
    role: '데모 스케줄 작업 마킹 → 이력 자동 생성',
    snippet: '@ErafScheduled(name="demo-heartbeat", recordHistory=true)',
  },
  {
    module: 'eraf-batch ★C065',
    moduleColor: 'green',
    api: 'BatchHistoryService.listExecutions/getExecution',
    role: '배치 실행/스텝 조회',
    snippet: 'batchHistory.listExecutions("demo-cleanup", p)',
  },
  {
    module: 'eraf-batch ★C065',
    moduleColor: 'green',
    api: 'JobExecutionDto · StepExecutionDto',
    role: '배치 실행/스텝 상태·카운트',
    snippet: 'stepExecutions.map(s => <StepProgressBar step={s} />)',
  },
  {
    module: 'eraf-batch ★C065',
    moduleColor: 'green',
    api: 'ScheduledJobLauncher.launch(jobName, params)',
    role: '데모 배치 수동 트리거',
    snippet: 'POST /batch/jobs/demo-cleanup/trigger',
  },
  {
    module: 'eraf-core C022',
    moduleColor: 'yellow',
    api: '@DistributedLock(key, failStrategy=THROW)',
    role: '동시 트리거 중복 방지',
    snippet: "@DistributedLock(key=\"'sched-trigger:' + #jobName\")",
  },
  {
    module: 'eraf-core C022',
    moduleColor: 'yellow',
    api: 'LockAcquisitionException → SCHED-409-001',
    role: '락 미획득 → 409 Conflict',
    snippet: 'error.code === "SCHED-409-001" → inline warn',
  },
  {
    module: 'eraf-core C002',
    moduleColor: 'blue',
    api: 'ApiResponse<T> · PageResponse<T>',
    role: '표준 응답 언래핑',
    snippet: 'if (d.success) return d.data',
  },
  {
    module: 'eraf-core C014',
    moduleColor: 'blue',
    api: '@Audited(action="BATCH_TRIGGERED")',
    role: '트리거 행위 자기 감사',
    snippet: '@Audited(action="BATCH_TRIGGERED", resource="batch-job")',
  },
  {
    module: 'eraf-data-jpa C041',
    moduleColor: 'green',
    api: 'SpecificationBuilder.eq/between',
    role: '이력 동적 검색',
    snippet: 'SpecBuilder.eq("taskName", t).between("startedAt", ...)',
  },
  {
    module: 'eraf-security C030',
    moduleColor: 'yellow',
    api: '@HasPermission("SCHEDULER_READ"/"SCHEDULER_TRIGGER")',
    role: '메서드 단위 권한 이중 방어',
    snippet: 'ButtonGuard requirePermission="SCHEDULER_TRIGGER"',
  },
];

/**
 * SchedulerCommonUsagePanel — 공통 모듈 시연 패널 (biz-foundation §4.11).
 */
export function SchedulerCommonUsagePanel() {
  const { t } = useTranslation();

  return (
    <CommonUsagePanel
      items={COMMON_USAGE_ITEMS}
      title={t('schedulerMonitor.commonUsage.title')}
      subtitle={t('schedulerMonitor.commonUsage.description')}
    />
  );
}
